import React, { useState, useContext, useEffect } from "react";
import Translation from "utils/Translation";
import { useAuth } from "react-oidc-context";
import { HotelContext } from "context/HotelContext";
import BreadCrumb from "component/Breadcrumb";
import ActionRSECard from "component/ActionRSECard";

const Actions = () => {
  const keycloak = useAuth();
  const { hId, lang } = useContext(HotelContext);

  const [actions, setActions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [noDataAvailable, setNoDataAvailable] = useState(false);

  const fetchActionsByHotel = () => {
    if (!keycloak.isAuthenticated || !keycloak.user?.access_token) {
      setHasError(true);
      setLoading(false);
      return;
    }

    setLoading(true);
    fetch(`/api/hotels/${hId}/actions?lang=${lang}`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + keycloak.user.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-front-token": "Bs#PSQyhy)!y9Ti{",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success === "OK" && data.actions.length > 0) {
          setActions(data.actions);
          setHasError(false);
          setNoDataAvailable(false);
        } else {
          setNoDataAvailable(true);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching actions:", error);
        setHasError(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (keycloak.isAuthenticated && hId) {
      fetchActionsByHotel();
    }
  }, [keycloak.isAuthenticated, hId, lang]);

  return (
    <div className="green-miles-actions-container">
      <BreadCrumb text={<Translation tag="ActionRSE_title" />} />
      <h1 className="h1-page">
        <Translation tag={"ActionRSE_title"} />
      </h1>

      <p className="cleaning-description">
        <Translation tag={"ActionRSE_text"} />
      </p>

      {loading ? (
        <div className="centered-message">Chargement des actions...</div>
      ) : hasError ? (
        <div className="centered-message">Erreur lors du chargement des actions. Veuillez réessayer</div>
      ) : noDataAvailable ? (
        <div className="centered-message">Aucune action disponible</div>
      ) : (
        <div className="actions-list">
          {actions.map((action) => (
            <React.Fragment key={action.actId}>
              <ActionRSECard key={action.actId} name={action.aadName} description={action.aadDescription} reward={action.actReward} picture={action.actPictureURL} language={lang} />
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

export default Actions;
